import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

const inventoryUrl = "/erp/inventory/transactions";

export const getInventories = createAsyncThunk(
  "ERP_inventory/getInventories",
  async (params) => {
    try {
      const response = await apiAxios.get(inventoryUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const createInventory = createAsyncThunk(
  "ERP_inventory/createInventory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(inventoryUrl, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateInventory = createAsyncThunk(
  "ERP_inventory/updateInventory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${inventoryUrl}/${id}`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const deleteInventory = createAsyncThunk(
  "ERP_inventory/deleteInventory",
  async (id, { rejectWithValue }) => {
    try {
      await apiAxios.delete(`${inventoryUrl}/${id}`);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const exportData = createAsyncThunk(
  'ERP_item/exportData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${inventoryUrl}/export`, {params, responseType: 'blob'});

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'inventory-transactions.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
  
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getInOutMaterials = createAsyncThunk(
  "ERP_inventory/getInOutMaterials",
  async (params) => {
    try {
      const response = await apiAxios.get(`${inventoryUrl}/in_out_material`, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const exportDataInOutMaterials = createAsyncThunk(
  'ERP_item/exportDataInOutMaterials',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${inventoryUrl}/export_in_out_material`, {params, responseType: 'blob'});

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'in-out-material.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
  
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getItemDimensionTransactions = createAsyncThunk(
  "ERP_inventory/getItemDimensionTransactions",
  async (params) => {
    try {
      const response = await apiAxios.get(`${inventoryUrl}/item_dimension_transactions`, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const exportDataItemDimensionTransactions = createAsyncThunk(
  'ERP_item/exportDataItemDimensionTransactions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${inventoryUrl}/export_item_dimension_transactions`, {params, responseType: 'blob'});

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'item-transactions.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
  
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const isRejectedAction = (action) => (action.type.startsWith("ERP_inventory/") || action.type.startsWith("ERP_item/")) && action.type.endsWith("/rejected");

const inventorySlice = createSlice({
  name: "erp_inventory",
  initialState: {
    items: [],
    total: 0,
    loading: false,
    error: null,
    gridParams: {
      page: 0,
      pageSize: 100,
      sortModel: [],
      filterModel: {}
    }
  },
  reducers: {
    setGridParams: (state, action) => {
      state.gridParams = { ...state.gridParams, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInventories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInventories.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.rows || [];
        state.total = action.payload.total || 0;
      })
      .addCase(getInventories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

export const { setGridParams, clearError } = inventorySlice.actions;
export default inventorySlice.reducer